export type HallRole = "operator" | "display";

let role: HallRole = "operator";

export function setHallRole(next: HallRole) {
  role = next;
}

export function getHallRole() {
  return role;
}

export function isHallDisplay() {
  return role === "display";
}
